import { createAsyncAction, createAction } from 'typesafe-actions';
import { RequestAssistanceDto } from '../dtos/requestAssistance';

export const requestAssistanceActions = createAsyncAction(
    'REQUEST_ASSISTANCE_REQUEST',
    'REQUEST_ASSISTANCE_SUCCESS',
    'REQUEST_ASSISTANCE_ERROR',
)<RequestAssistanceDto, undefined, string>();

